import SeoLandingPage from "@/components/SeoLandingPage";

const ForeclosureCleanout = () => (
  <SeoLandingPage
    slug="foreclosure-cleanout-wi"
    metaTitle="Foreclosure Cleanout WI | REO & Bank-Owned | 48-Hour Turn"
    metaDescription="Foreclosure cleanout services in Wisconsin for banks, asset managers, and investors. Trash-out, debris removal, and broom-clean turnover. Photo documentation included."
    h1="Foreclosure Cleanout Services in Wisconsin"
    heroImage="/images/garage.jpg"
    heroIntro="Bank-owned, pre-listing, or post-eviction — we trash-out and turn the property fast so you can list, board, or rekey on schedule."
    serviceName="Foreclosure Cleanout"
    bullets={[
      "Complete interior and exterior trash-out per HUD / Fannie Mae / Freddie Mac standards.",
      "Photo documentation: before, during, and after, time-stamped and uploaded same day.",
      "Personal-property handling per Wisconsin notice requirements.",
      "Yard debris, abandoned vehicles, and outbuilding contents removed.",
      "Coordination with locksmiths, boarding crews, and winterization vendors.",
      "Invoices ready for asset-manager reimbursement workflows.",
    ]}
    whyUs={[
      "Trusted by Wisconsin property preservation companies and regional banks since 2018.",
      "48-hour turnaround on most REO trash-outs in Northeast Wisconsin.",
      "Insured to $1M with crews who understand chain-of-custody requirements.",
      "Single point of contact — no sub-vendors, no surprise invoices.",
    ]}
    processSteps={[
      { title: "Work order received", detail: "Send us the address, scope, and any HUD/agency requirements. We confirm within hours." },
      { title: "Initial photo set", detail: "Crew arrives, captures the property condition, and uploads geo-tagged photos before touching anything." },
      { title: "Trash-out & cleanup", detail: "Interior, exterior, and outbuildings cleared. Hazardous items removed separately and documented." },
      { title: "Completion package", detail: "Final photos, invoice, and any required compliance forms delivered within 24 hours of completion." },
    ]}
    faqs={[
      { q: "Do you work with banks and asset managers?", a: "Yes. We handle REO and pre-foreclosure work for Wisconsin banks, credit unions, and national property-preservation firms. We're set up for net-30 invoicing and reimbursement-friendly documentation." },
      { q: "How fast can you turn a foreclosure property?", a: "Most single-family foreclosure trash-outs in Northeast Wisconsin are completed within 48 hours of the work order. Larger or hoarded properties may take 3–5 days." },
      { q: "Do you handle personal property left behind?", a: "Yes. We follow Wisconsin's abandoned-property notice requirements, photograph and inventory items of value, and coordinate with you on storage or disposal." },
      { q: "What areas in Wisconsin do you cover?", a: "We cover all of Northeast Wisconsin including Green Bay, Appleton, Oshkosh, Fond du Lac, Manitowoc, Sheboygan, and surrounding counties. Contact us for properties further afield." },
    ]}
    ctaHeadline="Need a trash-out this week?"
  />
);

export default ForeclosureCleanout;
